import { react, useState, useRef, useEffect } from 'react';
import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import TextField from '@mui/material/TextField';
import ReCAPTCHA from "react-google-recaptcha";
import Snackbar from '@mui/material/Snackbar';
import { useSnackbar } from 'notistack';
import LoadingButton from '@mui/lab/LoadingButton';
import TokenService from '../services/TokenService';

import ReactGA from 'react-ga4';
ReactGA.initialize([{ trackingId: process.env.REACT_APP_GOOGLE_TAG }]);

const ContactUs = () => {
    const [snackbar, setSnackbar] = useState({
        message: '',
        severity: 'info'
    });
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const captchaRef = useRef(null);
    const [contactName, setContactName] = useState('');
    const [contactEmail, setContactEmail] = useState('');
    const [contactMessage, setContactMessage] = useState('');
    const [sendingMessage, setSendingMessage] = useState(false);
    const [messageSent, setMessageSent] = useState(false);
    const [formValidation, setFormValidation] = useState({
        isValid: false,
        errors: []
    });

    useEffect(() => {
        if (window.location.href.indexOf('localhost') == -1 && window.location.href.toLowerCase().indexOf('test.sipzee.com') == -1) {
            ReactGA.send({ hitType: "pageview", page: '/Contact' });
        }
    }, []);

    function isValidated() {

        let isValid = true;
        let errors = [];
        if (contactName.trim() == '') {
            errors["contactName"] = "Missing your Name";
            isValid = false;
        }

        if (contactEmail.trim() == '') {
            errors["contactEmail"] = "Missing your Email";
            isValid = false;
        }
        else {
            if (!isValidEmail(contactEmail)) {
                errors["contactEmail"] = "Not a valid email";
                isValid = false;
            }
        }

        if (contactMessage.trim() == '') {
            errors["contactMessage"] = "Missing your Message";
            isValid = false;
        }

        const token = captchaRef.current.getValue();
        if (token.trim() == '') {
            errors["token"] = "Check here if you're human";
            isValid = false;
        }

        return {
            isValid: isValid,
            errors: errors
        }
    }

    function validateAndSend() {
        let validation = isValidated();

        if (validation.isValid) {

            setFormValidation(validation);

            const token = captchaRef.current.getValue();
            // post to server

            var postData = {
                name: contactName,
                email: contactEmail,
                message: contactMessage,
                token: token
            }
            setSendingMessage(true);
            TokenService.post(postData, 'CustomerContact', '')
                .then((response) => {
                    setSendingMessage(false);
                    if (response.Result == "SUCCESS") {
                        setMessageSent(true);
                    }
                    else {
                        enqueueSnackbar(response.Message, {
                            variant: 'error',
                        });
                    }
                })
                .catch((response) => {
                    enqueueSnackbar('Oops, something went wrong', {
                        variant: 'error',
                    });
                    if (response !== null) {
                        setSendingMessage(false);
                    }
                });


            captchaRef.current.reset();
        }
        else {
            setFormValidation(validation);
        }
    }

    function isValidEmail(email) {
        return /\S+@\S+\.\S+/.test(email);
    }

    let panel = null;
    if (messageSent) {
        panel = <div style={{marginTop:'50px'} } >Thank you for your message<br />We will respond to you as soon as possible.</div>;
        
    }
    else {

        panel =
            <div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', padding: '10px' }}>
                <div>
                    <div style={{ color: 'var(--sipzee-grey)', fontSize: '18pt', fontWeight: 'bold' }}>
                        Have a question or comment?
                    </div>

                    <div style={{
                        marginTop: '15px', fontSize: '14pt', display: 'flex', flexDirection: 'column'
                    }}>
                        Check out our
                        <Button
                            component={Link}
                            to='/FAQ'
                            style={{ alignSelf: 'center', maxWidth: '225px' }}
                            sx={{ my: 2, display: 'flex', background: 'var(--sipzee-yellow)' }}
                        ><HelpOutlineIcon style={{ alignSelf: 'center' }} /> Frequently Asked Questions
                        </Button>
                    </div>

                    <div style={{
                        marginTop: '15px', fontSize: '14pt', display: 'flex', flexDirection: 'column'
                    }}>
                        Or send us a note:
                    </div>

                    <div>
                        <form>
                            <div style={{ marginTop: '15px' }}>
                                <TextField error={formValidation.errors['contactName'] !== undefined} label="Name" onChange={(e) => setContactName(e.target.value)} value={contactName} variant="outlined" />
                                <div className='FormFieldErrorDescription'> {formValidation.errors['contactName'] !== undefined ? formValidation.errors['contactName'] : ''}</div>
                            </div>
                            <div style={{ marginTop: '15px' }}>
                                <TextField error={formValidation.errors['contactEmail'] !== undefined} label="Email" onChange={(e) => setContactEmail(e.target.value)} value={contactEmail} variant="outlined" />
                                <div className='FormFieldErrorDescription'> {formValidation.errors['contactEmail'] !== undefined ? formValidation.errors['contactEmail'] : ''}</div>
                            </div>
                            <div style={{ marginTop: '15px' }}>
                                <TextField multiline rows={4} error={formValidation.errors['contactMessage'] !== undefined} label="Message" onChange={(e) => setContactMessage(e.target.value)} value={contactMessage} variant="outlined" />
                                <div className='FormFieldErrorDescription'> {formValidation.errors['contactMessage'] !== undefined ? formValidation.errors['contactMessage'] : ''}</div>
                            </div>

                            <div style={{ display: 'flex', justifyContent: 'center', marginTop: '15px' }}>
                                <ReCAPTCHA
                                    sitekey={process.env.REACT_APP_SITE_KEY}
                                    ref={captchaRef}
                                />

                            </div>
                            <div style={{ display: 'flex', justifyContent: 'center', marginTop: '15px' }}>
                                <div className='FormFieldErrorDescription'> {formValidation.errors['token'] !== undefined ? formValidation.errors['token'] : ''}</div>
                            </div>


                            <LoadingButton loading={sendingMessage} loadingIndicator="Sending" style={{ marginTop: '15px' }} variant="contained" color="sipzeeGreen" onClick={() => validateAndSend()}>Send</LoadingButton >
                        </form>
                    </div>
                </div>
            </div>
    }

    return panel;
}

export default ContactUs;